export default "__VITE_ASSET__319ed125__"